<template>
  <div :class="[bem.b(), prepareClassNames()]" :style="{ ...prepareStyles() }">
    <div v-for="(field, index) in list" :key="index" :class="bem.e('item')">
      <span :class="bem.e('label')">{{ getFieldName(field) }}</span>
      <span :class="bem.e('value')">{{ getFieldValue(field) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { createNameSpace } from '@el-plus/utils/bem'
import { footerInfoProps, type FooterInfoFieldConfig } from './footer-info'
import { prepareClassNames, prepareStyles } from '@el-plus/utils/props'

defineOptions({
  name: 'EpFooterInfo',
  inheritAttrs: false,
})

const bem = createNameSpace('footer-info')
const props = defineProps(footerInfoProps)

const getFieldName = (field: FooterInfoFieldConfig) => {
  const fieldMapValue = props.fieldMap[field.prop]
  if (
    fieldMapValue &&
    typeof fieldMapValue === 'object' &&
    'name' in fieldMapValue
  ) {
    return fieldMapValue.name || field.name
  }
  return field.name
}

const getFieldValue = (field: FooterInfoFieldConfig) => {
  const fieldMapValue = props.fieldMap[field.prop]
  if (fieldMapValue) {
    if (typeof fieldMapValue === 'function') {
      return fieldMapValue(props.modelValue[field.prop], props.modelValue)
    }
    if (typeof fieldMapValue === 'object' && 'formatter' in fieldMapValue) {
      return fieldMapValue.formatter(
        props.modelValue[field.prop],
        props.modelValue,
      )
    }
  }
  if (field.formatter) {
    return field.formatter(props.modelValue[field.prop], props.modelValue)
  }
  return props.modelValue[field.prop] || ''
}
</script>
